export default __webpack_public_path__ + "static/media/ddf-grafik_04.613bd69f.png";